import { Turbo } from '@hotwired/turbo-rails';
import { Controller } from '@hotwired/stimulus';
import { useMutationObserver } from 'stimulus-library/dist';

const { navigator } = Turbo;

export default class extends Controller {
  initialize() {
    this.mutate = this.mutate.bind(this);
  }

  connect() {
    useMutationObserver(this, this.element, this.mutate, { attributes: true });
  }

  mutate(entries) {
    entries.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
        const src = this.element.getAttribute('src');
        if (src != null) {
          navigator.history.push(new URL(src));
        }
      }
    });
  }
}
